"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.string.pad-start");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _commissionBaseDeductionSetting = require("@/api/orderManagement/commissionBaseDeductionSetting");
var _IllegalOrder = _interopRequireDefault(require("./components/IllegalOrder.vue"));
var _orderDetail = _interopRequireDefault(require("./components/orderDetail.vue"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommissionBaseDeductionSetting',
  components: {
    IllegalOrder: _IllegalOrder.default,
    orderDetail: _orderDetail.default
  },
  data: function data() {
    return {
      options: [{
        value: 'TB',
        label: '淘宝'
      }, {
        value: 'JD',
        label: '京东'
      }, {
        value: 'PDD',
        label: '拼多多'
      }, {
        value: 'WPH',
        label: '唯品会'
      }, {
        value: 'DY',
        label: '抖音'
      }, {
        value: 'KS',
        label: '快手'
      }, {
        value: 'MT',
        label: '美团'
      }, {
        value: 'ELM',
        label: '饿了么'
      }, {
        value: 'DD',
        label: '滴滴出行'
      }, {
        value: 'QF',
        label: '直充卡券'
      }, {
        value: 'OT',
        label: '在线点单'
      }, {
        value: 'SN',
        label: '苏宁'
      }, {
        value: 'DMJH',
        label: '多麦聚合'
      }, {
        value: 'TXYX',
        label: '腾讯云选'
      }, {
        value: 'ALI',
        label: '1688'
      }],
      ruleForm: {
        unionCode: '',
        syncTime: ''
      },
      rules: {
        unionCode: [{
          required: true,
          message: '请选择渠道',
          trigger: 'change'
        }],
        syncTime: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }]
      },
      dialogVisible: false,
      loadingTb: false,
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            var end = new Date();
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨日',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1); // 设置为昨天
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本月',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1); // 设置为本月的第一天
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            var end = new Date(); // 本月的今天
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setMonth(start.getMonth() - 1); // 设置为上个月的第一天
            start.setDate(1);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            var end = new Date();
            end.setDate(0); // 设置为上个月的最后一天
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: 'first',
      pagination: {
        total: 0 // 条数
      },
      queryData: {
        unionCode: 'TB',
        orderNo: '',
        memberId: '',
        phoneNo: '',
        keyWord: '',
        status: '',
        orderType: '',
        incomeRate: '',
        income: '',
        orderSubType: '',
        createTimeStart: '',
        createTimeEnd: '',
        page: 1,
        size: 10
      },
      searchTime: '',
      dataList: []
    };
  },
  created: function created() {
    this.setTimes();
    if (sessionStorage.getItem('user_Order')) {
      this.queryData = JSON.parse(sessionStorage.getItem('user_Order'));
    }
    this.listOrderPagedApi();
  },
  methods: {
    onProductInformation: function () {
      var _onProductInformation = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(data) {
        var params, res, url, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                unionCode: data.unionCode,
                itemId: data.itemSign
              };
              _context.n = 1;
              return (0, _commissionBaseDeductionSetting.loadItem)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                if (res.data.itemUrl) {
                  url = res.data.itemUrl.includes('https') || res.data.itemUrl.includes('https');
                  if (url) {
                    window.open(res.data.itemUrl);
                  } else {
                    window.open('https://' + res.data.itemUrl);
                  }
                } else {
                  this.$notify.error({
                    title: '温馨提示',
                    message: '商品链接不存在'
                  });
                }
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function onProductInformation(_x) {
        return _onProductInformation.apply(this, arguments);
      }
      return onProductInformation;
    }(),
    close: function close() {
      this.$refs['ruleForm8'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: (0, _validate.throttle)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // console.log(this.ruleForm.unionCode, this.ruleForm.syncTime)
          (0, _commissionBaseDeductionSetting.syncByTime)({
            unionCode: _this.queryData.unionCode,
            syncTime: _this.ruleForm.syncTime
          }).then(function (res) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功！请刷新页面查看同步结果 (数据更新可能延迟)'
            });
            _this.close();
          });
        } else {
          console.log('error submit!!');
        }
      });
    }, 2500),
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       // console.log(this.ruleForm.unionCode, this.ruleForm.syncTime)
    //       syncByTime({
    //         unionCode: this.queryData.unionCode,
    //         syncTime: this.ruleForm.syncTime
    //       }).then(res => {
    //         this.$notify.success({
    //           title: '温馨提示',
    //           message: '操作成功！请刷新页面查看同步结果 (数据更新可能延迟)'
    //         })
    //         this.close()
    //       })
    //     } else {
    //       console.log('error submit!!')
    //     }
    //   })
    // },
    setTimes: function setTimes() {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      var start = "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
      var end = "".concat(year, "-").concat(month, "-").concat(day, " 23:59:59");
      this.searchTime = [start, end];
      console.log('this.searchTime', this.searchTime);
      if (this.searchTime === null || this.searchTime === '') {
        this.queryData.createTimeStart = '';
        this.queryData.createTimeEnd = '';
      } else {
        this.queryData.createTimeStart = this.searchTime[0];
        this.queryData.createTimeEnd = this.searchTime[1];
      }
    },
    onIllegalOrder: function onIllegalOrder() {
      this.$refs.IllegalOrder.open();
    },
    viewDetails: function viewDetails(id) {
      this.$refs.orderDetail.open(id);
    },
    onTabClick: function onTabClick(value) {
      this.queryData.size = 10;
      this.queryData.page = 1;
      this.onInquire();
    },
    onInquire: function onInquire() {
      if (this.searchTime === null || this.searchTime === '') {
        this.queryData.createTimeStart = '';
        this.queryData.createTimeEnd = '';
      } else {
        this.queryData.createTimeStart = this.searchTime[0];
        this.queryData.createTimeEnd = this.searchTime[1];
      }
      sessionStorage.setItem('user_Order', JSON.stringify(this.queryData));
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listOrderPagedApi();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        unionCode: 'TB',
        orderNo: '',
        memberId: '',
        phoneNo: '',
        keyWord: '',
        status: '',
        orderType: '',
        incomeRate: '',
        income: '',
        orderSubType: '',
        createTimeStart: '',
        createTimeEnd: '',
        page: 1,
        size: 10
      };
      this.setTimes();
      this.listOrderPagedApi();
      sessionStorage.setItem('user_Order', JSON.stringify(this.queryData));
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listOrderPagedApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listOrderPagedApi();
    },
    listOrderPagedApi: function () {
      var _listOrderPagedApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData); // if (params.unionCode === 'TB') {
              //   params.unionCode = ''
              // }
              this.loadingTb = true;
              _context2.n = 1;
              return (0, _commissionBaseDeductionSetting.listOrderPagedApi)(params);
            case 1:
              res = _context2.v;
              this.loadingTb = false;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.loadingTb = false;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function listOrderPagedApi() {
        return _listOrderPagedApi2.apply(this, arguments);
      }
      return listOrderPagedApi;
    }(),
    onDetails: function onDetails(value) {
      this.$router.push({
        path: 'orderDetails',
        query: {
          orderNo: value.orderNo,
          unionCode: value.unionCode
        }
      });
    },
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(text) {
        var _this2 = this;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              try {
                this.$copyText(text).then(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function copyText(_x2) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.memberName
        }
      });
    }
  }
};